import { ModularAuth } from "../../components/FirebaseAuth/firebase";
import { recordUserActivity } from "../activityLog";

const ACTIVITY_ACTIONS = new Map([
    ["signed in", "signed_in"],
    ["signed_in", "signed_in"],
    ["signed out", "signed_out"],
    ["signed_out", "signed_out"],
    ["password updated", "password_updated"],
    ["password_updated", "password_updated"],
    ["user name updated", "user_name_updated"],
    ["user_name_updated", "user_name_updated"],
    ["phone number updated", "phone_number_updated"],
    ["phone_number_updated", "phone_number_updated"],
    ["email address updated", "email_address_updated"],
    ["email_address_updated", "email_address_updated"],
    ["business type updated", "business_type_updated"],
    ["business_type_updated", "business_type_updated"],
    ["phone verified", "phone_verified"],
    ["phone_verified", "phone_verified"],
    ["identity verified", "identity_verified"],
    ["identity_verified", "identity_verified"],
    ["document submitted", "document_submitted"],
    ["document_submitted", "document_submitted"],
]);

const normalizeActivityAction = (action) => {
    const value = String(action || "").trim().toLowerCase();
    return ACTIVITY_ACTIONS.get(value) || value.replace(/\s+/g, "_");
};

export const log = (action, callback) => {
    const currentUser = ModularAuth.currentUser;
    if (!currentUser) {
        if (callback) callback(false);
        return;
    }

    recordUserActivity(normalizeActivityAction(action)).then((success) => {
        if (callback) callback(success);
    });
}
export const SIGN_IN = 'signed_in';
export const UPDATE_PASSWORD = 'password_updated';
export const UPDATE_USERNAME = 'user_name_updated';
export const UPDATE_PHONE = 'phone_number_updated';
export const UPDATE_EMAIL = 'email_address_updated';
export const UPDATE_TYPE = 'business_type_updated';
export const PHONE_VERIFIED = 'phone_verified';
export const IDENTITY_VERIFIED = 'identity_verified';
export const DOCUMENT_SUBMITTED = 'document_submitted';
export const SIGN_OUT = 'signed_out';
